import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "../../lib/chalkApi";
import { ChalkCard } from "./primitives";

const ROWS = [
  { key: "email", label: "Email alerts", sub: "Cancellations, delays, time changes and Chalk Talk posts." },
  { key: "push", label: "Push alerts", sub: "The same alerts on this phone once push is turned on." },
  { key: "reminders", label: "Reminders", sub: "Game-day morning (8 AM) and volunteer duty the day before." },
];

// Family alert settings. ChalkOS always respects these; the in-app banner still shows.
export default function AlertPrefsCard() {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => {
    api.getPrefs().then(setPrefs).catch(() => setPrefs({ email: true, push: true, reminders: true }));
  }, []);

  useEffect(() => {
    if (prefs && window.location.hash === "#alert-settings") {
      document.getElementById("alert-settings")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [prefs]);

  async function flip(key) {
    const next = { ...prefs, [key]: !prefs[key] };
    setPrefs(next);
    try {
      await api.setPrefs({ push: next.push, email: next.email, reminders: next.reminders,
        ...(Object.keys(next.by_trigger || {}).length ? { by_trigger: next.by_trigger } : {}) });
    } catch (e) {
      setPrefs(prefs);
      toast.error(e.message || "Couldn't save that setting.");
    }
  }

  if (!prefs) return null;
  return (
    <div id="alert-settings" style={{ scrollMarginTop: 80 }}>
    <ChalkCard data-testid="alert-prefs-card">
      {ROWS.map((r, i) => (
        <div key={r.key} style={{ display: "flex", alignItems: "center", gap: 12, paddingTop: i ? 14 : 0 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 500, color: "var(--chalk-board)" }}>{r.label}</div>
            <div style={{ fontSize: 13, color: "var(--chalk-muted)", marginTop: 2, lineHeight: 1.4 }}>{r.sub}</div>
          </div>
          <button type="button" role="switch" aria-checked={!!prefs[r.key]} data-testid={`alert-pref-${r.key}`}
            onClick={() => flip(r.key)}
            style={{ width: 46, height: 26, borderRadius: 13, border: "none", cursor: "pointer", position: "relative",
              background: prefs[r.key] ? "var(--green-mid)" : "rgba(0,0,0,0.15)", transition: "background-color .2s" }}>
            <span style={{ position: "absolute", top: 3, left: prefs[r.key] ? 23 : 3, width: 20, height: 20,
              borderRadius: 10, background: "#fff", transition: "left .2s" }} />
          </button>
        </div>
      ))}
      <div style={{ fontSize: 12, color: "var(--chalk-muted)", marginTop: 14 }} data-testid="alert-prefs-banner-note">
        Cancellation and delay banners always show inside ChalkOS. No text messages are sent.
      </div>
    </ChalkCard>
    </div>
  );
}
